import React from 'react';

import { CommonPropTypes } from '../IconTypes';

const Profile: React.FC<CommonPropTypes> = ({ className }) => {
  return (
    <svg className={className} viewBox='0 0 54 54' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M27 0C12.1121 0 0 12.1123 0 26.9997C0 41.8884 12.1121 54 27 54C41.8879 54 54 41.8877 54 26.9997C54 12.1116 41.8879 0 27 0ZM45.819 43.3829C43.4764 39.1194 38.3778 34.5005 34.7898 32.6047C34.7025 32.6933 34.6179 32.7861 34.5279 32.872C32.4019 34.9249 29.729 36.0553 27 36.0553C24.0368 36.0553 21.3199 34.753 19.217 32.5986C15.6338 34.489 10.5263 39.116 8.18237 43.3849C4.35617 38.9955 2.03053 33.266 2.03053 26.9997C2.03053 13.2318 13.2316 2.03056 27 2.03056C40.7684 2.03056 51.9695 13.2318 51.9695 26.9997C51.9695 33.2646 49.6445 38.9942 45.819 43.3829ZM27 10.9501C21.5778 10.9501 17.181 14.8495 17.181 21.5239C17.181 28.1977 21.5778 33.6085 27 33.6085C29.285 33.6085 31.388 32.6473 33.0571 31.0357C35.3475 28.8238 36.819 25.3854 36.819 21.5239C36.819 14.8488 32.4236 10.9501 27 10.9501Z'
        fill='#fbfbfb'
      />
    </svg>
  );
};

export default Profile;
